import {
  Button,
  ReferenceInput,
  SelectInput,
  NumberInput,
  required,
  minValue,
  maxValue,
  useNotify,
  useRefresh,
} from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import { Grid, Tooltip } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";

const AddPeriodsDialog = ({
  id,
  periods = [],
  usedDurationInDays = 0,
  effectiveDurationCapInDays = 0,
  advancedSpecializationId,
}) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const hasUnpaidPeriod = periods.some(period => !period.isPaid);
  const remainingDays = Math.max(effectiveDurationCapInDays - usedDurationInDays, 0);

  const blockedReason = hasUnpaidPeriod
    ? "Предишният период трябва да е маркиран като платен, преди да добавите нов."
    : remainingDays <= 0
      ? "Достигнат е максималният лимит дни за обучението."
      : null;

  const handleSubmit = async data => {
    const payload = {
      startDate: data.startDate,
      durationInDays: data.durationInDays,
      buildingId: data.buildingId,
      professorId: data.professorId,
    };
    await dataProvider.customRequest(
      specialistRequests.addAdvancedSpecializationSpecialistPeriods(id),
      payload,
      "POST",
    );
    notify("Успешно добавихте период", { type: "success" });
    refresh();
  };

  if (blockedReason) {
    return (
      <Tooltip title={blockedReason}>
        <span>
          <Button
            label="Добави период"
            startIcon={<AddIcon />}
            variant="contained"
            sx={{ m: 2 }}
            disabled
          />
        </span>
      </Tooltip>
    );
  }

  return (
    <FormModal
      dialogSize="md"
      titleContent={"Добавяне на период"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добави период"
          startIcon={<AddIcon />}
          variant="contained"
          sx={{ m: 2 }}
        />
      }
    >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <CustomDateInput
            source="startDate"
            label="Начална дата"
            validate={required()}
            noTime
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <NumberInput
            source="durationInDays"
            label="Продължителност (дни)"
            validate={[
              required(),
              minValue(1),
              maxValue(remainingDays, `Максимум ${remainingDays} дни (оставащи до лимита)`),
            ]}
            helperText={`Оставащи дни до лимита: ${remainingDays}`}
            onWheel={e => e.target.blur()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="buildingId"
            reference={specialistRequests.getAdvancedSpecializationsBuildingsSelect(advancedSpecializationId)}
          >
            <SelectInput
              label="Сграда"
              optionText="buildingNameBg"
              validate={required()}
              fullWidth
            />
          </ReferenceInput>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
        >
          <ReferenceInput
            source="professorId"
            reference={specialistRequests.getProfessorsByAdvancedSpecializationSelect(advancedSpecializationId)}
          >
            <SelectInput
              optionText="names"
              label="Преподавател"
              emptyText={false}
            />
          </ReferenceInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default AddPeriodsDialog;
